import { IlluConceptFlowLinks } from "@/app/(components)/generics/Illustrations/IlluConceptFlowLinks/IlluConceptFlowLinks";
import { ConceptFlowGutter as Gutter } from "@/app/types/home/ConceptFlow";
import { FLOW_GUTTER_HEIGHT } from "../ConceptFlow.logic";
import styles from "../ConceptFlow.module.css";
import ConceptFlowPacket from "./ConceptFlowPacket";
import ConceptFlowTagPair from "./ConceptFlowTagPair";

type Props = {
  gutter: Gutter;
};

export default function ConceptFlowGutter(props: Props) {
  const { gutter } = props;

  return (
    <div
      className={`${styles.gutter} ${gutter.isOutgoing ? styles.gutterOut : styles.gutterIn}`}
      aria-hidden="true"
    >
      <IlluConceptFlowLinks height={FLOW_GUTTER_HEIGHT} links={gutter.links}>
        <g className={styles.packets}>
          {gutter.packets.map((packet) => (
            <ConceptFlowPacket packet={packet} key={packet.id} />
          ))}
        </g>
      </IlluConceptFlowLinks>
      {gutter.tags.map((pair) => (
        <ConceptFlowTagPair className={styles.edgeTag} pair={pair} key={pair.id} />
      ))}
    </div>
  );
}
